export default function Input({label,onBlur=null, type, className, placeholder, formik, name, dir, disabled = false, readOnly = false, ref, value = null,autoFocus=false}) {
    return (
        <div className="mb-3 position-relative">
            {
                label && <label className="form-label">{label}</label>
            }
            <input type={type} className={`form-control ${className} ${formik.errors[name] && formik.touched[name] ? "is-invalid" : ""}`} dir={dir}
                   name={name} placeholder={placeholder} value={value || formik.values[name]?value?value:formik.values[name]:""}
                   onChange={formik.handleChange} disabled={disabled} onBlur={onBlur?onBlur:formik.handleBlur} readOnly={readOnly} ref={ref ? ref : null}
                   autoComplete="off"
                   autoFocus={autoFocus}
            />
            {
                formik.touched[name] && formik.errors[name] ? (<div className="invalid-feedback">{formik.errors[name]}</div>) : null
            }
        </div>
    )
}